// We use hardcoded logos links assuming 'source_slug' = 'app_slug'
// Must make sure that all sources has corresponding app and this app has logo. 
// Two types of logos - 'full' and 'square' (default)

import { imageSizeByClass } from '../../../lib/helpers'
import { websiteImageBaseUrl } from '../../../lib/constants'

export default function SourceLogo({ source, className, option='square' }) {  

  // get logo size in px by ClassName h- attribute (example: h-48)
  const size = imageSizeByClass(className)
  const height = size
  const width = (option === 'full') ? '' : size


  const srcPath = (option === 'full') ? `${websiteImageBaseUrl}/automationtools/logos/full/` : `${websiteImageBaseUrl}/apps/logos/`
  const srcFile = (option === 'full') ? `${source?.slug}.png` : `${source?.slug}_${size}.png`
  const src = source ? `${srcPath}${srcFile}` : ''
  const alt = source?.name || source?.slug
  

  // If image is missing then use default SR logo in black and white
  // const addDefaultSrc = (e) => {
  //   e.target.src = 'https://stackreaction.com/img/logo/logo-32px-bw.png';
  //   // e.target.classList.toggle('filter');
  //   // e.target.classList.toggle('grayscale');
  // }
   
  return (
    <>      
      <img src={src} alt={alt} title={alt} width={width} height={height}
           className={className} 
          //  onError={(e) => {addDefaultSrc(e)}}
      />
    </>
  )
}


// 20.03.2023 - Commented out 'OnEroor '